(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-hero-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const MOBILE_BREAKPOINT = 992;

    const setupCollectionHeroDescription = (rootElement) => {
      if (rootElement.dataset.initialized === 'true') {
        return;
      }

      const sectionId = rootElement.dataset.sectionId;
      const description = document.getElementById(`CollectionHeroDescription-${sectionId}`);
      const toggle = rootElement.querySelector('[data-role="toggle"]');
      const sectionContainer = rootElement.closest('[data-collection-hero-section]');

      if (!description || !toggle || !sectionContainer) {
        return;
      }

      const isDescriptionOverflowing = () => {
        const wasCollapsed = description.classList.contains('is-collapsed');

        description.classList.remove('is-collapsed');
        const fullHeight = description.scrollHeight;

        description.classList.add('is-collapsed');
        const collapsedHeight = description.clientHeight;

        if (!wasCollapsed) {
          description.classList.remove('is-collapsed');
        }

        return fullHeight > collapsedHeight + 1;
      };

      const updateVisibility = () => {
        const isMobile = window.innerWidth < MOBILE_BREAKPOINT;

        if (!isMobile) {
          description.classList.remove('is-collapsed');
          toggle.classList.add('hidden');
          toggle.setAttribute('aria-expanded', 'false');
          toggle.textContent = toggle.dataset.labelExpand;
          sectionContainer.classList.remove('is-mobile-compact');
          return;
        }

        const shouldShowToggle = isDescriptionOverflowing();
        toggle.classList.toggle('hidden', !shouldShowToggle);

        if (!shouldShowToggle) {
          description.classList.remove('is-collapsed');
          toggle.setAttribute('aria-expanded', 'false');
          toggle.textContent = toggle.dataset.labelExpand;
          sectionContainer.classList.remove('is-mobile-compact');
          return;
        }

        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        description.classList.toggle('is-collapsed', !isExpanded);
        toggle.textContent = isExpanded ? toggle.dataset.labelCollapse : toggle.dataset.labelExpand;
        sectionContainer.classList.toggle('is-mobile-compact', !isExpanded);
      };

      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        const nextExpanded = !expanded;

        toggle.setAttribute('aria-expanded', String(nextExpanded));
        description.classList.toggle('is-collapsed', !nextExpanded);
        toggle.textContent = nextExpanded ? toggle.dataset.labelCollapse : toggle.dataset.labelExpand;
        sectionContainer.classList.toggle('is-mobile-compact', !nextExpanded);
      });

      updateVisibility();
      requestAnimationFrame(updateVisibility);
      window.addEventListener('load', updateVisibility, { once: true });
      window.addEventListener('resize', updateVisibility);
      rootElement.dataset.initialized = 'true';
    };

    const init = () => {
      document.querySelectorAll('.js-collection-hero-description').forEach((rootElement) => {
        setupCollectionHeroDescription(rootElement);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', () => {
      init();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
